'use client';

import { useQuery } from '@tanstack/react-query';

import { ALL_MODULES_PAGE_SIZE } from '@/modules/players/v2/tabs/constants';
import { TeamLeagueStatus, TeamLeagueTypes } from '@/types/playerTeamLeagues.types';
import { getPlayerTeamLeagueFavorites } from '@/utils/actions/players/non-edit/getPlayerTeamLeagueFavorites';
import { getPlayerTeamLeagues } from '@/utils/actions/players/non-edit/getPlayerTeamLeagues';

const PLAYER_TEAM_LEAGUES_QUERY_KEY = 'player-team-leagues';

interface UsePlayerTeamLeaguesArgs {
  playerId: string;
  playerSlug: string;
  activeTeamLeagueType: TeamLeagueTypes;
  status: TeamLeagueStatus;
  searchParams: {
    [key: string]: string;
  };
}

export const usePlayerTeamLeagues = ({
  playerId,
  playerSlug,
  activeTeamLeagueType,
  status,
  searchParams,
}: UsePlayerTeamLeaguesArgs) => {
  const isFavorites = activeTeamLeagueType === TeamLeagueTypes.Favorited;
  const statusType = status === TeamLeagueStatus.Future ? 'upcoming' : 'past';
  const currentPage = Number(searchParams.page) || 1;

  return useQuery({
    queryKey: [
      PLAYER_TEAM_LEAGUES_QUERY_KEY,
      playerId,
      playerSlug,
      activeTeamLeagueType,
      status,
      searchParams,
    ],

    queryFn: async () => {
      return isFavorites
        ? getPlayerTeamLeagueFavorites({
            id: playerId,
            type: statusType,
            pageSize: ALL_MODULES_PAGE_SIZE,
            page: currentPage,
            search: searchParams.search,
          })
        : getPlayerTeamLeagues({
            playerSlug: playerSlug,
            leagueStatus: status,
            managerOf: activeTeamLeagueType === TeamLeagueTypes.Managing ? 'true' : 'false',
            pageSize: ALL_MODULES_PAGE_SIZE,
            currentPage: currentPage,
            search: searchParams.search,
          });
    },

    keepPreviousData: true,
  });
};
